import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, Router, Routes } from '@angular/router';
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { provideAuth, getAuth, Auth, browserLocalPersistence, initializeAuth, browserSessionPersistence, inMemoryPersistence } from '@angular/fire/auth';
import { provideFirestore, getFirestore, Firestore } from '@angular/fire/firestore';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { ApplicationInitStatus, importProvidersFrom, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

import { LoginComponent } from './app/pages/login/login.component';
import { HomeComponent } from './app/pages/home/home.component';
import { DashboardTenantComponent } from './app/pages/dashboard-tenant/dashboard-tenant.component';
import { DashboardAdminComponent } from './app/pages/dashboard-admin/dashboard-admin.component';
import { RegisterComponent } from './app/pages/register/register.component';
import { adminGuard, tenantGuard,loginGuard, applicationsGuard, adminHomeGuard } from './app/guards/auth.guard';
import { ProfileComponent } from './app/pages/profile/profile.component';
import { PayComponent } from './app/pages/pay/pay.component';
import { ApplyComponent } from './app/pages/apply/apply.component';
import { ApplyDetailComponent } from './app/pages/apply-detail/apply-detail.component';
import { EditRentalComponent } from './app/pages/edit-rental/edit-rental.component';
import { AddRentalComponent } from './app/pages/add-rental/add-rental.component';
import { DocumentsComponent } from './app/pages/documents/documents.component';
import { SuccessComponent } from './app/pages/success/success.component';
import { ApplicationSubmissionComponent } from './app/pages/application-submission/application-submission.component';
import { SubscriptionSuccessComponent} from './app/pages/subscription-success/subscription-success.component';
import { PaymentsComponent } from './app/pages/payments/payments.component';
import { AdminPaymentsComponent } from './app/pages/admin-payments/admin-payments.component';
import { AdminLeasesComponent } from './app/pages/admin-leases/admin-leases.component';
import { AdminApplicationsComponent } from './app/pages/admin-applications/admin-applications.component';
import { AdminTenantsComponent } from './app/pages/admin-tenants/admin-tenants.component';
import { AdminRentalsComponent } from './app/pages/admin-rentals/admin-rentals.component';
import { AdminShellComponent } from './app/layouts/admin-shell/admin-shell.component';
import { PublicLayoutComponent } from './app/layouts/public-layout/public-layout.component';
import { TenantLayoutComponent } from './app/layouts/tenant-layout/tenant-layout.component';
import { Chart, registerables } from 'chart.js';
import { ApplicationPrintComponent } from './app/shared/application-print/application-print.component';
Chart.register(...registerables);

// Define your app routes here
const routes: Routes = [
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'login', component: LoginComponent, canActivate: [loginGuard] },
      { path: 'register', component: RegisterComponent },
      { path: 'apply', component: ApplyComponent },
      { path: 'rental/:id', component: ApplyDetailComponent },
      { path: 'application-submission/:rentalId', component: ApplicationSubmissionComponent },
      {
        path: 'print-application/:roundId/:applicationId',
        component: ApplicationPrintComponent
      }
    ]
  },

  {
    path: 'tenant',
    component: TenantLayoutComponent,
    canActivate: [tenantGuard],
    children: [
      { path: '', component: DashboardTenantComponent },
      { path: 'documents', component: DocumentsComponent },
      { path: 'payments', component: PaymentsComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'pay',component: PayComponent},
      { path: 'success', component: SuccessComponent},
      { path: 'payments', component: PaymentsComponent}
    ]
  },

  {
    path: 'admin',
    component: AdminShellComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardAdminComponent,
        canActivate: [adminGuard]
      },
      {
        path: 'tenants',
        component: AdminTenantsComponent,
        canActivate: [adminGuard]
      },
      {
        path: 'rentals',
        component: AdminRentalsComponent,
        canActivate: [adminGuard]
      },
      {
        path: 'applications',
        component: AdminApplicationsComponent,
        canActivate: [applicationsGuard]
      },
      {
        path: 'leases',
        component: AdminLeasesComponent,
        canActivate: [adminGuard]
      },
      {
        path: 'payments',
        component: AdminPaymentsComponent,
        canActivate: [adminGuard]
      },
      {
        path: 'edit/:id',
        component: EditRentalComponent,
        canActivate: [adminGuard]
      },
    ]
  },
  { path: '**', redirectTo: '' }
];




bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),

    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideFunctions(() => getFunctions(undefined, 'us-central1')),

    importProvidersFrom(ReactiveFormsModule),
  ],
}).catch(err => console.error(err));